import './App.scss';
import {useNavigate} from "react-router-dom";
import AppRoutes from './routes';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { UserProvider } from './_contexts/UserContext';

import {config, BYPASS_AUTH} from "./config";
const oktaAuth = new OktaAuth(config.oidc);

function App() {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth,  originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  // If in bypass mode, skip Okta Security wrapper
  if (BYPASS_AUTH) {
    return (
      <div className="App">
        <div className={"wrapper"}>
          <div className={"container"}>
            <UserProvider>
              <AppRoutes/>
            </UserProvider>
          </div>
        </div>
      </div>
    );
  }

  // Normal Okta authentication flow
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <div className="App">
        <div className={"wrapper"}>
          <div className={"container"}>
            <UserProvider>
              <AppRoutes/>
            </UserProvider>
          </div>
        </div>
      </div>
    </Security>
  );
}

export default App;
